module.exports = __webpack_public_path__ + "img/modal-el-lock.4ec02a89.svg";